function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm.65 15.933c-.475.08-1.42.277-1.9.317-.406.034-.79-.199-1.024-.533a1.25 1.25 0 01-.15-1.144l1.89-5.198H7.5c-.002-1.083.81-1.88 1.85-2.185.496-.146 1.42-.346 1.9-.315.288.018.79.199 1.024.533.234.334.29.761.15 1.144l-1.89 5.198H12.5a2.213 2.213 0 01-1.849 2.183zm.6-9.683a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z",
  fill: "#879097"
});

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
}

export default SvgInfo;